import { NgModule, PipeTransform, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';

@Pipe({
  name: 'missingInputPipe',
})
export class MissingInputPipe implements PipeTransform {
  transform(
    value: string[],
    language: string
  ): string | null {

    let convertedName = '';

    for (let i = 0; i < value.length; i++) {

      switch (value[i]) {
        case 'itemID':
          convertedName += '產品服務編號';
          break;
        case 'itemCateName':
          convertedName += '產品服務分類名稱';
          break;
        case 'standardPrice':
          convertedName += '標準單價';
          break;
        case 'packagePayValue':
          convertedName += '付款金額';
          break;

        case 'itemNeedTime':
          convertedName += '服務時間(分鐘)';
          break;



        default:
          convertedName += value[i];
          break;
      }

      console.log('convertedName name = ' + convertedName);

      convertedName += '\n';
    }

    console.log('convertedName = ' + convertedName);


    const returnMsg = '必需輸入 : ' + '\n' + convertedName;
    alert(returnMsg);


    return returnMsg;

  }


}

@NgModule({
  declarations: [MissingInputPipe],
  imports: [CommonModule],
  exports: [MissingInputPipe], // export list here
  providers: []
})
export class MissingInputPipeModule { }
